import { post } from './http.js'

// 周转金
export const payRevFunds = (params) => post('/unicom/cluster/user/payRevFunds', params)
export const revFundsRecords = (params) => post('/unicom/cluster/user/revFundsRecords', params)
export const applyRefund = (params) => post('/unicom/cluster/user/applyRefund', params)

// 保险
export const payInsure = (params) => post('/unicom/cluster/user/payInsure', params)
export const insureRecords = (params) => post('/unicom/cluster/user/insureRecords', params)
export const insureDetail = (params) => post('/unicom/cluster/user/insureDetail', params)

// 设备缴费（打卡器）
export const payDkq = (params) => post('/unicom/cluster/user/payDkq', params)
export const refundDkq = (params) => post('/unicom/cluster/user/refundDkq', params)
export const sPayDkq = (params) => post('/unicom/cluster/user/sPayDkq', params)
export const dkqOrderList = (params) => post('/unicom/cluster/user/dkqOrderList', params)
